
export enum Path {
  Home = '/register',
  Home2 = '/home',
  About = '/about',
  //ContactUs = '/contact',

  Login = '/login',
  UserDashboard = '/user/dashboard',
  IdCard = '/user/id-card',
  Facilitator = '/',

  AdminDashboard = '/admin/dashboard',






}
